export const TRANSLATION_SCOPE = 'settingsVersionModule';
export const TRANSLATION_VERSION_SCOPE = [TRANSLATION_SCOPE, 'version'];
